import { createSelector } from 'reselect';

import { DEVICE_TYPES } from '../constants';
import type { RootState } from 'store';

const getDeviceType = (state: RootState) => state.deviceType;

export default createSelector([getDeviceType], deviceType => deviceType === DEVICE_TYPES.MOBILE);
